<template>
  <!-- hero section -->
  <div class="hero">
    <section>
      <div class="content">
        <h1>Hayche Reviews</h1>
        <p class="description">
          The best reviews are passionate and personal. They offer a short narrative, important details, and a helpful tip or two for other consumers.
          Think about your recent experience at an establishment - could you put details in there that would help future consumers like you?
        </p>
        <div class="cta-grid">
          <a href="https://reviews.hayche.net">
            <button class="button-pulse">Create a reviewer account</button>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
/* start of hero */
.hero {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 80%),
    url("https://res.cloudinary.com/hayche-network/image/upload/v1646928349/website/images/reviews/hero_o7ck8y.jpg");
  width: 100%;
  height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  display: grid;
  align-items: center;
}

.hero .content {
  width: 700px;
  height: 100%;
  display: grid;
  align-items: center;
  float: right;
}

.hero .content h1 {
  font-style: normal;
  font-weight: 300;
  font-size: 50px;
  line-height: 1.3;
  color: white;
}

@media (max-width: 768px) {
  .hero .content h1 {
    font-size: 25px;
    font-weight: 600;
    line-height: 1.5;
  }
}

.hero .content .heading {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: white;
  margin-bottom: 22px;
}

.hero .content .description {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 1.5;
  color: white;
  margin-bottom: 40px;
}

.hero .content img {
  width: 372px;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .hero .content img {
    width: 100%;
  }

  .hero .content {
    width: 100%;
  }

  .hero .content h1 {
    font-size: 40px;
    line-height: 50px;
  }
}

.cta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 50px;
  width: 500px;
}

@media (max-width: 768px) {
  .cta-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    row-gap: 20px;
    width: 100%;
  }
}

.cta-grid button {
  width: 100%;
  font-weight: 300;
  font-size: 14px;
  color: #3a3a3c;
  border: none;
  border-radius: var(--button-border-radius);
  background-color: white;
  padding: 15px;
  cursor: pointer;
}
/* end of hero */
</style>